import * as RadixCollapsible from '@radix-ui/react-collapsible'
import cn from 'classnames'
import type { CollapsibleContentProps } from './Collapsible.types'
import styles from './Collapsible.module.css'

export function Root({ ...props }: React.ComponentPropsWithoutRef<typeof RadixCollapsible.Root>) {
  return <RadixCollapsible.Root data-collapsible-root {...props} />
}

Root.displayName = 'Collapsible.Root'

export function Content({ className, duration, ...props }: CollapsibleContentProps) {
  return (
    <RadixCollapsible.Content
      data-collapsible-content
      className={cn(styles.content, className)}
      style={duration ? ({ '--_duration': duration } as React.CSSProperties) : undefined}
      {...props}
    />
  )
}

Content.displayName = 'Collapsible.Content'

export function Trigger({ ...props }: React.ComponentPropsWithoutRef<typeof RadixCollapsible.Trigger>) {
  return <RadixCollapsible.Trigger {...props} />
}

Trigger.displayName = 'Collapsible.Trigger'
